/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const selectPolicyDataFormValues = (state: { policyData: any; }) => state.policyData.formValues;
export const selectDefaultValues = (state: { policyData: any; }) => state.policyData.defaultValues;
export const selectFilteredValues = (state: { policyData: any; }) => state.policyData.filteredValues;
export const selectHierarchyValues = (state: { policyData: any; }) => state.policyData.hierarchyValues;
export const selectFormValidationValues = (state: { policyData: any; }) => state.policyData.formValidation;